module.exports = {
	"personName": "Aleksandr SaPozhkov",
	"titleImage": "MCSE_SharePoint_Blk.png",
	"jobTitle": "SharePoint Solutions Expert",
	"personAnouncement": "I am glad you made it!",
	"smallText": "Keep scrolling to find out why you will want to hire me.",
	"sections": [
		{
			"id": "intro",
			"title": "Overview",
			"anouncement": "General information",
			"icon": "Home",
			"moodPhoto": "inferno",
			"text": "Back in 2006 I worked as a Microsoft solutions engineer for Maxsoft, which is the leader in the Krasnoyarsk IT market. The company met an order from Telesphere, local television company, ordered to replace their old-fashioned network-drive-styled document sharing with high quality web solution based on the SharePoint Portal Server 2003. Since that time I have developed a multitude of intranet portals for different organizations. Please find this <a href='https://1drv.ms/b/s!AuySu5nQcwVzgZ1lu1ZH2qvW8SFmmA' target='_blank'><i class='ms-Icon ms-Icon--Print' aria-hidden='true'></i> version of my resume.</a> and this <a href='https://1drv.ms/w/s!AuySu5nQcwVzgaAfrD1zFPEA16Glbg' target='_blank'><i class='ms-Icon ms-Icon--Print' aria-hidden='true'></i> version of my CV.</a>",
			"currentJob": {
				"icon": "Work",
				"label": "Current Job",
				"text": "Currently, I work for Sopra Steria, a leading IT company in Europe. My job is a mix of solution design on the SharePoint platform with providing DevOps expertise. Not only do I appreciate the technical challenges here, but also the fact that this company encourages me to develop soft skills and to appreciate the balance between the value that we bring to the company and our cost, which is crucial in today's market."
			},
			"humanLanguages": {
				"icon": "ReminderGroup",
				"label": "Spoken Languages",
				"text": "My mother tongue is Russian and I have a good command of English: I recently took the IELTS exam, that placed my usage of the language at C1-C2 from one skill to another."
			},
			"certification": {
				"icon": "Certificate",
				"label": "Qualifications",
				"text": "I regularly examine myself so apart from SharePoint Solutions Expert I have earned many other qualifications and certifications. Feel free to read about them on <a href='https://mcp.microsoft.com/Anonymous/Transcript/Validate' target='_blank'>Microsoft Certified Professional web site</a> using Transcript ID 693553 and Access Code alexengine."
			},
			"assignmentTypes": {
				"label": "Project Experience",
				"maximumRating": 5,
				"items": [
					{
						"title": "Intranet implementation",
						"rating": 5
					},
					{
						"title": "Document management system implementation",
						"rating": 4
					},
					{
						"title": "Custom system development",
						"rating": 3
					},
					{
						"title": "Internet site building",
						"rating": 2
					},
					{
						"title": "System migration",
						"rating": 2
					},
					{
						"title": "Single Sign On implementation",
						"rating": 1
					}
				]
			},
			"keySkills": {
				"label": "Skills",
				"maximumRating": 25,
				"items": [
					{
						"title": "DevOps",
						"rating": 25
					},
					{
						"title": "SolutionDesign",
						"rating": 22
					},
					{
						"title": "Capacity planning",
						"rating": 21
					},
					{
						"title": "Development",
						"rating": 19
					},
					{
						"title": "Branding",
						"rating": 18
					},
					{
						"title": "Presentation",
						"rating": 16
					},
					{
						"title": "Administration",
						"rating": 15
					},
					{
						"title": "Teaching",
						"rating": 14
					},
					{
						"title": "Tech leading",
						"rating": 12
					}
				]
			},
			"keyTechnologies": {
				"label": "Technologies",
				"maximumRating": 11,
				"items": [
					{
						"title": "SharePoint",
						"rating": 11
					},
					{
						"title": "PowerShell",
						"rating": 9
					},
					{
						"title": "Office 365",
						"rating": 7
					},
					{
						"title": "Javascript",
						"rating": 6.8
					},
					{
						"title": "HTML/CSS",
						"rating": 6.8
					},
					{
						"title": "Enterprise IT infrastructure",
						"rating": 6.5
					},
					{
						"title": "CSOM",
						"rating": 6.2
					},
					{
						"title": "SSOM",
						"rating": 6
					},
					{
						"title": "SQL",
						"rating": 4.5
					},
					{
						"title": "MS Office",
						"rating": 4
					},
					{
						"title": "C#",
						"rating": 2
					},
					{
						"title": "SPFx",
						"rating": 1.7
					},
					{
						"title": "ReactJS",
						"rating": 1.7
					},
					{
						"title": "PHP",
						"rating": 1
					},
					{
						"title": "Azure",
						"rating": 1
					},
					{
						"title": "Active Directory",
						"rating": 1
					},
					{
						"title": "TCP/IP",
						"rating": 1
					},
					{
						"title": "DNS",
						"rating": 1
					}
				]
			},
			"keyAdvantages": {
				"label": "Qualities",
				"contentItems": [
					{
						"title": "Business improvement",
						"image": "bdev-orig.jpg",
						"text": "The primary goal of each task I perform is the improvement of your business. After many years in IT I realize perfectly well and always keep in mind that any improvement should bring value to the business and sponsors. Without this in mind even a brilliant effort can end up being ineffective.",
						"example": "In 2016, while working for the Kentor company I developed a SharePoint Fastrack packaged service to facilitate customer engagement in new Intranet projects."
					},
					{
						"title": "Passionate about IT",
						"image": "passion-orig.jpg",
						"text": "Information technology is my obsession, which means I never get tired of doing this. It also means you do not have to motivate me to do a great job since it is my vocation.",
						"example": "Even when a project manager says 'Ok, let's admit we lost this opportunity', I don't give up and accept the impossibility of the task, because I know that nothing is impossible in IT."
					},
					{
						"title": "Long-term vision",
						"image": "longterm-orig.jpg",
						"text": "Not only are known issues my constant priority, but the many years of experience behind me also allow me to foresee customers' future needs and verify them with stakeholders.",
						"example": "When developing a request management system for the Bavaria company, I insisted on building a deployment script, which in its turn saved dozens of hours that we would have spent on deploying all the system changes in numerous development and production envionrments."
					}
				]
			}
		},
		{
			"id": "architect",
			"title": "SharePoint Architect",
			"anouncement": "Let's make this solution even greater!",
			"icon": "Org",
			"moodPhoto": "design",
			"keyAssets": {
				"label": "In the course of my SharePoint journey I've gained architectural skills",
				"contentItems": [
					{
						"title": "Enterprise demands understanding",
						"image": "selectserviceThumb.jpg",
						"text": "I have been discussing business demands with the top management of different companies and I perfectly understand their interests and the uniqueness of each business. I have also collaborated a lot with IT departments and for these reasons I clearly understand the causes and consequences of their policies and requirements.",
						"example": "In 2015 Kentor was contracted by a union umbrella organization in Stockholm. Choosing the right type of SSL and SSO signing certificates was a challenging task, but since I had had previous network administration experience, I was able to make the right decision."
					},
					{
						"title": "Prototyping",
						"image": "model-home-printing-3d-object.jpg",
						"text": "Making use of a proper prototyping approach for the proof of a concept or for functional prototyping, guarantees the optimal resource consumption, which is essential, especially at the beginning of a project.",
						"example": "When a customer ordered Kentor to develop a system with complicated screen forms, I quickly developed form prototypes using Infopath in order to identify requirements."
					},
					{
						"title": "Negotiating with customers and interpreting their demands",
						"image": "swayprojectThumb.png",
						"text": "Often a project budget can be saved just by correctly interpreting customer needs. On numerous occasions I only had to talk to the project sponsor to explain that it was reasonable to postpone building one or another system feature. On other occasions I needed to discuss requirements to realize that some use cases were distorted or misinterpret by sales or project managers.",
						"example": "Initially a customer requested an employee examination system with a statistics page. When I discussed this demand with the client, it turned out that using Excel reports would be a convenient solution for users, which reduced development efforts by hundreds of hours."
					},
					{
						"title": "Evaluating multiple ways of implementing the solution",
						"image": "differentapproachThumb.png",
						"text": "Instead of implementing the solution via first completing the implementation approach, I prefer to go the extra mile and consider possible future changes in demand and to consider other implementation options.",
						"example": "The most popular framework for system elements provisioning in SharePoint is PnP Provisioning Engine. However, I insisted on comparing this tool with Meta2 for one particular solution and it appeared that Meta2 was more convenient for the given task."
					},
					{
						"title": "Design patterns applying",
						"image": "crystalstructureThumb.png",
						"text": "It is no secret that software development is not only a kind of magic, but also a craft with known practices and patterns, which help to achieve better results with less effort.",
						"example": "Applying these patterns according to formal and assumed requirements made solution design less time consuming in many project."
					},
					{
						"title": "Foresee and address future customer demands",
						"image": "headphonesvrThumb.jpg",
						"text": "It is crucial for an architect to not constrain the solution by current demands only, but also to keep in mind possible future improvement directions.",
						"example": "In one project in 2016 for a Stockholm union organization, we needed a search function for content in multiple site collections of a custom document management system. The most obvious decision was to base a filter on the system URL. However, I insisted on filtering based on content types instead. One year later the customer decided to build one more system in the same URL, so the decision regarding content types filtering allowed the use of one URL for multiple systems without any conflicts."
					},
					{
						"title": "Complex SharePoint farm topologies design",
						"image": "appdesignThumb.jpg",
						"text": "Some farms that I've deployed were not trivial and that gave me unique experience in building optimal configurations for specific requirements.",
						"example": "In 2015 I designed a farm for an umbrella organization and the best solution was to apply multitenancy for isolating search, managed metadata and user profiles."
					}
				]
			}
		},
		{
			"id": "developer",
			"title": "Developer",
			"anouncement": "Find out if my competence matches what you need",
			"icon": "Code",
			"moodPhoto": "typing",
			"keyAssets": {
				"label": "Software development has changed a great deal since I developed my first commercial code. Here are a few examples you might consider relevant to your tasks",
				"contentItems": [
					{
						"title": "DevOps",
						"image": "Senior-DevOps-Engineer-Administrator.png",
						"text": "In SharePoint world, these principles are not too common. However, I got hands on experience in running infrastructure as code, configuration as code as well as in continuous testing and delivery. In order to meet challenges of agile projects I improved our team delivery routines with Azure Pipelines, Jenkins, Vagrant, Packer, Terraform, KitchenCI, Azure ARM, DCS, Ansible, Puppet and many other essential DevOps tools."
					},
					{
						"title": "SPFx Delve web part for Kentor packaged Intranet",
						"image": "TrendingWPThumb.png",
						"text": "I am sure that using cutting edge technology is the best for building long running solutions. This web part was supposed to show relevant documents on the Intranet home page. It was developed as a component of the Kentor package for building Intranet solution for their customers. It was my first experience of developing for SPFx. This particular web part was developed with the use of GQL, ReactJS and SCSS.",
						"fullImage": "TrendingWPFull.png"
					},
					{
						"title": "Responsive home page for TeleComputing Intranet Solution",
						"image": "TCIntraThumb.png",
						"text": "In 2014 Kentor was a subsidiary of TeleComputing and I developed a packaged Intranet solution so that TeleComputing could deliver it to their customers. My task was to develop a structure, installation package and unique layout that could be used for both desktop and mobile displays.",
						"fullImage": "TCIntraFull.png"
					},
					{
						"title": "Branding for SharePoint solutions",
						"image": "sevminbrandingThumb.jpg",
						"text": "I am passionate about the look and feel of solutions I deliver. So I put a lot of effort into polishing component's UI and making it stable to minimize the probability of further changes breaking the layout. In order to achieve this I use both CSS and JavaScript for such customizations. I have carried out dozens of branding tasks and I know both the development workflow and SharePoint styles.",
						"fullImage": "sevminbrandingFull.png"
					},
					{
						"title": "Using built-in SharePoint functionality instead of reinventing the wheel",
						"image": "metadatafilterThumb.png",
						"text": "Being familiar with SharePoint for already more than ten years I know all its features like the back of my hand. I therefore believe in using high level development: customizing existing SharePoint components and features instead of developing something from scratch. The example shows the usage of the built in SharePoint library metadata navigation, although I had to apply some styling to it.",
						"fullImage": "metadatafilterFull.png"
					},
					{
						"title": "Fractal Provisioner: Client Script SharePoint artefacts provisioning",
						"image": "provisioningcodeThumb.png",
						"text": "When SharePoint Online had just started to become fashionable, Kentor needed a provisioning engine for deploying packaged solutions to multiple customers. I developed <a href='http://fractalprovisioner.codeplex.com'>this framework</a> that allows the user to define the structure for deployment via an XML document.",
						"fullImage": "provisioningcodeFull.png"
					},
					{
						"title": "Agile development",
						"image": "scrumThumb.png",
						"text": "I usually work in projects with the adoption of some agile methodology with granting roles and regular standup meetings. Usually I prefer to work with a team because I appreciate deep expertise and specialization. However, I am also used to being responsible for the whole task or project solely."
					}
				]
			}
		},
		{
			"id": "administrator",
			"title": "Administrator",
			"anouncement": "One more role that often stands apart from development",
			"icon": "DeveloperTools",
			"moodPhoto": "hardware",
			"text": "Before coming across SharePoint I have gained an invaluable experience of network administrator. Thorough understanding computer network fundamentals gives me a great advantage when the discussion comes to integrating new solution with existing enterprise application and infrastructure.",
			"keyAssets": {
				"label": "Here is what distinguishes me in this role:",
				"contentItems": [
					{
						"title": "Automated deployment",
						"image": "machineworkThumb.jpg",
						"text": "I believe every configurational change should be automated and scripted as much as possible. I use the DSC framework together with PowerShell scripting. Not only does this save time on applying the same change in multiple environments, such as development, test and production, but it also improves the probability that the change will be documented and it will be possible to find its trace in versioning control systems."
					},
					{
						"title": "Configuration management",
						"image": "gearsThumb.jpg",
						"text": "This role requires discipline and experience. After spending in total hundreds of hours on fixing mistakes in the deployment procedure, I have learned the value of routines: issuing release notes, updating configuration documentation, logging, roll back planning, etc."
					},
					{
						"title": "Capacity planning",
						"image": "datacenterThumb.jpg",
						"text": "I have troubleshooted performance issues multiple times and I know what the most likely bottlenecks are and how to plan the farm topology preventively."
					},
					{
						"title": "Troubleshooting",
						"image": "healthcareThumb.jpg",
						"text": "Again, since I have significant experience as a network administrator, I perfectly understand the nuances of support and problem solving in a corporate environment. In the course of my life I have developed many useful habits and methods and have also developed a number of tools for effective searching for the intrinsic problem and solution."
					}
				]
			}
		},
		{
			"id": "assignments",
			"title": "Assignments",
			"anouncement": "A list of activities I hope you will find useful to know about",
			"icon": "IssueTracking",
			"moodPhoto": "achievement",
			"text": "Choose appropriate filter:",
			"employers": {
				"items": [
					{
						"title": "Maxsoft",
						"beginning": "2003-09-01",
						"ending": "2006-10-30",
						"logo": "maxsoftlogo.png",
						"position": "MS Solutions Engineer"
					},
					{
						"title": "Kentor",
						"beginning": "2014-02-28",
						"ending": "Currently working",
						"logo": "maxsoftlogo.png",
						"position": "SharePoint Senior Developer"
					}
				]
			},
			"assignments": {
				"featuredFilterText": "Show featured projects only",
				"roleFiltersHeaderText": "My role:",
				"roles": [
					"DevOps",
					"Architect",
					"Developer",
					"Administrator",
					"Analyst",
					"Project Manager"
				],
				"technologyFiltersHeaderText": "Technology:",
				"technologies": [
					"SharePoint Online",
					"SharePoint 2016",
					"SharePoint 2013",
					"SharePoint 2010",
					"SharePoint",
					"Azure",
					"Multitenancy",
					"Client JavaScript",
					"CSOM"
				],
				"items": [
					{
						"title": "SharePoint 2013 to 2016 Migration",
						"client": "Unionen",
						"ending": "2018-03-31",
						"beginning": "2017-10-01",
						"clientLogo": "unionenlogo.png",
						"clientIndustry": "Public Services",
						"employer": "Sopra Steria",
						"type": "Upgrade",
						"roles": [
							"DevOps",
							"Architect"
						],
						"technologies": [
							"SharePoint 2016",
							"SharePoint"
						],
						"featured": "true"
					},
					{
						"title": "Multiple SharePoint Farms Maintenance",
						"client": "Unionen",
						"ending": "Currently working",
						"beginning": "2016-01-03",
						"clientLogo": "unionenlogo.png",
						"clientIndustry": "Public Services",
						"employer": "Kentor",
						"type": "Maintenance",
						"roles": [
							"DevOps"
						],
						"technologies": [
							"SharePoint 2013",
							"SharePoint"
						],
						"featured": "false"
					},
					{
						"title": "Multiple SharePoint Farms Maintenance",
						"client": "FASAB6f",
						"ending": "Currently working",
						"beginning": "2015-04-08",
						"clientLogo": "fasablogo.png",
						"clientIndustry": "Public Services",
						"employer": "Kentor",
						"type": "Maintenance",
						"roles": [
							"DevOps"
						],
						"technologies": [
							"SharePoint 2013",
							"SharePoint"
						],
						"featured": "false"
					},
					{
						"title": "SharePoint Solutions Maintenance",
						"client": "PwC",
						"ending": "Currently working",
						"beginning": "2016-02-26",
						"clientLogo": "pwclogo.png",
						"employer": "Kentor",
						"roles": [
							"DevOps"
						],
						"technologies": [
							"SharePoint 2013",
							"SharePoint"
						],
						"featured": "false"
					},
					{
						"title": "SharePoint Solutions Maintenance",
						"client": "Sveriges Ingenjörers",
						"ending": "Currently working",
						"beginning": "2017-02-01",
						"clientLogo": "silogo.png",
						"employer": "Kentor",
						"roles": [
							"DevOps"
						],
						"technologies": [
							"SharePoint 2013",
							"SharePoint"
						],
						"featured": "false"
					},
					{
						"title": "DMS Improvements",
						"client": "Unionen",
						"ending": "2018-03-31",
						"beginning": "2017-06-01",
						"clientLogo": "unionenlogo.png",
						"employer": "Kentor",
						"roles": [
							"DevOps"
						],
						"technologies": [
							"SharePoint 2013",
							"SharePoint"
						],
						"featured": "false"
					},
					{
						"title": "SharePoint Solutions Performance Optimization",
						"client": "PwC",
						"ending": "2017-08-31",
						"beginning": "2017-03-15",
						"clientLogo": "pwclogo.png",
						"employer": "Kentor",
						"roles": [
							"DevOps"
						],
						"technologies": [
							"SharePoint 2013",
							"SharePoint",
							"Desired State Configuration"
						],
						"featured": "true"
					},
					{
						"beginning": "2017-02-03",
						"ending": "2017-06-09",
						"client": "Unionen",
						"clientLogo": "unionenlogo.png",
						"clientIndustry": "Public Services",
						"employer": "Kentor",
						"type": "Custom development",
						"title": "Personal Library Implementation",
						"roles": [
							"DevOps"
						],
						"technologies": [
							"SharePoint 2013",
							"SharePoint"
						],
						"featured": "true"
					},
					{
						"title": "Pilot Migration to Online",
						"client": "BW Offshore",
						"ending": "2017-02-18",
						"beginning": "2017-01-14",
						"clientLogo": "bwologo.png",
						"employer": "Kentor",
						"roles": [
							"Administrator"
						],
						"technologies": [
							"SharePoint 2013",
							"SharePoint Online",
							"SharePoint"
						],
						"featured": "true"
					},
					{
						"title": "Employee Profile Photo Synchronization",
						"client": "Kentor",
						"ending": "2017-01-24",
						"beginning": "2016-10-16",
						"clientLogo": "kentorlogo.png",
						"employer": "Kentor",
						"roles": [
							"Developer"
						],
						"technologies": [
							"SharePoint 2013",
							"SharePoint"
						],
						"featured": "false"
					},
					{
						"title": "SharePoint Fastrack Implemenation",
						"client": "Western Bulk",
						"ending": "2017-01-03",
						"beginning": "2016-12-22",
						"clientLogo": "wblogo.png",
						"employer": "Kentor",
						"roles": [
							"DevOps"
						],
						"technologies": [
							"SharePoint Online",
							"Client JavaScript",
							"SharePoint"
						],
						"featured": "false"
					},
					{
						"beginning": "2016-09-01",
						"ending": "2016-12-26",
						"client": "Bavaria",
						"clientLogo": "bavarialogo.png",
						"clientIndustry": "Retail",
						"employer": "Kentor",
						"type": "Custom development",
						"title": "Sales management automation",
						"roles": [
							"DevOps",
							"Administrator"
						],
						"technologies": [
							"SharePoint Online",
							"Azure",
							"SharePoint"
						],
						"featured": "true"
					},
					{
						"title": "SharePoint Fastrack Implemenation",
						"client": "Elkonor",
						"ending": "2016-12-20",
						"beginning": "2016-11-21",
						"clientLogo": "elkonorlogo.png",
						"employer": "Kentor",
						"roles": [
							"DevOps"
						],
						"technologies": [
							"SharePoint Online",
							"Client JavaScript",
							"SharePoint"
						],
						"featured": "false"
					},
					{
						"title": "Solution Migration",
						"client": "Red Cross",
						"ending": "2016-10-04",
						"beginning": "2016-04-15",
						"clientLogo": "rklogo.png",
						"employer": "Kentor",
						"roles": [
							"Developer",
							"Administrator"
						],
						"technologies": [
							"SharePoint 2013",
							"SharePoint Online",
							"SharePoint"
						],
						"featured": "true"
					},
					{
						"title": "DMS Implementation",
						"client": "Unionen",
						"ending": "2016-07-31",
						"beginning": "2016-03-01",
						"clientLogo": "unionenlogo.png",
						"employer": "Kentor",
						"roles": [
							"Architect",
							"DevOps"
						],
						"technologies": [
							"SharePoint 2013",
							"CSOM",
							"Client JavaScript",
							"SharePoint"
						],
						"featured": "false"
					},
					{
						"title": "Intranet Farm Migration",
						"client": "Unionen",
						"ending": "2016-07-05",
						"beginning": "2015-03-15",
						"clientLogo": "unionenlogo.png",
						"employer": "Kentor",
						"roles": [
							"Administrator",
							"Developer"
						],
						"technologies": [
							"SharePoint 2013",
							"Client JavaScript",
							"SharePoint"
						],
						"featured": "false"
					},
					{
						"beginning": "2016-03-14",
						"ending": "2016-05-23",
						"client": "Unionen",
						"clientLogo": "unionenlogo.png",
						"clientIndustry": "Public Services",
						"employer": "Kentor",
						"type": "Custom development",
						"title": "Single Sign On implementation",
						"roles": [
							"Developer",
							"Architect"
						],
						"technologies": [
							"SharePoint 2013",
							"SharePoint"
						],
						"featured": "true"
					},
					{
						"title": "Migration to Online",
						"client": "Harvey Nash",
						"ending": "2016-05-11",
						"beginning": "2016-05-03",
						"clientLogo": "hnlogo.png",
						"employer": "Kentor",
						"roles": [
							"Developer"
						],
						"technologies": [
							"SharePoint 2013",
							"SharePoint Online",
							"SharePoint"
						],
						"featured": "false"
					},
					{
						"beginning": "2016-01-11",
						"ending": "2016-03-02",
						"client": "Karsten Moholt",
						"clientLogo": "kmlogo.png",
						"clientIndustry": "Manufacturing",
						"employer": "Kentor",
						"type": "SharePoint Fastrack",
						"title": "SharePoint Fastrack deployment",
						"roles": [
							"Developer",
							"Architect",
							"Administrator"
						],
						"technologies": [
							"SharePoint Online",
							"Client JavaScript",
							"SharePoint"
						],
						"featured": "true"
					},
					{
						"title": "Extranet Farm Migration",
						"client": "Unionen",
						"ending": "2016-03-01",
						"beginning": "2015-11-20",
						"clientLogo": "unionenlogo.png",
						"employer": "Kentor",
						"roles": [
							"Administrator",
							"Developer"
						],
						"technologies": [
							"SharePoint 2013",
							"SharePoint"
						],
						"featured": "false"
					},
					{
						"title": "SSO implementation",
						"client": "PwC",
						"ending": "2016-02-26",
						"beginning": "2015-10-30",
						"clientLogo": "pwclogo.png",
						"employer": "Kentor",
						"roles": [
							"Administrator"
						],
						"technologies": [
							"SharePoint 2013",
							"SharePoint"
						],
						"featured": "false"
					},
					{
						"title": "SharePoint Fastrack Implemenation",
						"client": "Martinsen",
						"ending": "2016-02-16",
						"beginning": "2016-01-12",
						"clientLogo": "martinsenlogo.png",
						"employer": "Kentor",
						"roles": [
							"Developer"
						],
						"technologies": [
							"SharePoint Online",
							"Client JavaScript",
							"SharePoint"
						],
						"featured": "false"
					},
					{
						"title": "Migrating to Online",
						"client": "Tradedoubler",
						"ending": "2016-01-29",
						"beginning": "2016-01-12",
						"clientLogo": "tradedoublerlogo.png",
						"employer": "Kentor",
						"roles": [
							"Administrator"
						],
						"technologies": [
							"SharePoint Online",
							"SharePoint"
						],
						"featured": "false"
					},
					{
						"title": "Client SharePoint Farms Maintenance",
						"client": "TeleComputing",
						"ending": "2015-12-31",
						"beginning": "2014-02-28",
						"clientLogo": "tclogo.png",
						"employer": "Kentor",
						"roles": [
							"Administrator",
							"Developer"
						],
						"technologies": [
							"SharePoint 2013",
							"SharePoint 2010",
							"SharePoint 2007",
							"SharePoint Online",
							"Client JavaScript",
							"SharePoint"
						],
						"featured": "false"
					},
					{
						"title": "SharePoint Fastrack Implemenation",
						"client": "Aleris",
						"ending": "2015-09-22",
						"beginning": "2015-05-07",
						"clientLogo": "alerislogo.png",
						"employer": "Kentor",
						"roles": [
							"Developer"
						],
						"technologies": [
							"SharePoint Online",
							"Client JavaScript",
							"SharePoint"
						],
						"featured": "false"
					},
					{
						"title": "SharePoint Fastrack Development",
						"client": "Kentor",
						"ending": "2015-07-15",
						"beginning": "2015-03-15",
						"clientLogo": "kentorlogo.png",
						"employer": "Kentor",
						"roles": [
							"Architect",
							"Developer"
						],
						"technologies": [
							"SharePoint Online",
							"Client JavaScript",
							"SharePoint"
						],
						"featured": "false"
					},
					{
						"title": "SharePoint Fastrack Implemenation",
						"client": "Grieg Group",
						"ending": "2015-07-02",
						"beginning": "2015-06-04",
						"clientLogo": "greiglogo.png",
						"employer": "Kentor",
						"roles": [
							"Developer"
						],
						"technologies": [
							"SharePoint Online",
							"Client JavaScript",
							"SharePoint"
						],
						"featured": "false"
					},
					{
						"title": "Intranet Farm Migration",
						"client": "Mestergruppen",
						"ending": "2015-06-17",
						"beginning": "2015-04-09",
						"clientLogo": "mestergruppenlogo.png",
						"employer": "Kentor",
						"roles": [
							"Administrator"
						],
						"technologies": [
							"SharePoint 2013",
							"SharePoint"
						],
						"featured": "false"
					},
					{
						"title": "Document Management System",
						"client": "FASAB6f",
						"ending": "2015-04-08",
						"beginning": "2014-10-10",
						"clientLogo": "fasablogo.png",
						"clientIndustry": "Public services",
						"employer": "Kentor",
						"type": "Document management system implementation",
						"roles": [
							"Developer",
							"Administrator"
						],
						"technologies": [
							"SharePoint 2013",
							"Multitenancy",
							"SharePoint"
						],
						"featured": "true"
					},
					{
						"title": "Intranet Upgrade",
						"client": "Rema 1000",
						"ending": "2015-01-16",
						"beginning": "2014-10-02",
						"clientLogo": "remalogo.png",
						"employer": "Kentor",
						"roles": [
							"Administrator"
						],
						"technologies": [
							"SharePoint 2010",
							"SharePoint 2013",
							"SharePoint"
						],
						"featured": "false"
					},
					{
						"title": "Intranet Package Development",
						"client": "TeleComputing",
						"ending": "2014-09-02",
						"beginning": "2014-04-06",
						"clientLogo": "tclogo.png",
						"employer": "Kentor",
						"roles": [
							"Architect",
							"Developer"
						],
						"technologies": [
							"SharePoint 2013",
							"Client JavaScript",
							"SharePoint"
						],
						"featured": "true"
					},
					{
						"beginning": "2013-11-21",
						"ending": "2014-02-25",
						"client": "Lenta",
						"clientLogo": "lentalogo.png",
						"clientIndustry": "Retail Chain",
						"employer": "Conteq",
						"type": "Project Management Automation",
						"title": "Project Management Automation",
						"roles": [
							"Administrator"
						],
						"technologies": [
							"SharePoint 2010",
							"Project Server",
							"SharePoint"
						]
					},
					{
						"beginning": "2013-08-20",
						"ending": "2014-02-14",
						"client": "A Plus Development",
						"clientLogo": "apluslogo.png",
						"clientIndustry": "Property Development",
						"employer": "Conteq",
						"type": "Intranet Implementation",
						"title": "Intranet Implementation",
						"roles": [
							"Analyst",
							"Project Manager",
							"Developer",
							"Administrator"
						],
						"technologies": [
							"SharePoint 2013",
							"SharePoint"
						]
					},
					{
						"beginning": "2013-10-01",
						"ending": "2014-01-20",
						"client": "Gazprom Gazomotornoye Toplivo",
						"clientLogo": "gplogo.png",
						"clientIndustry": "Gaz and Oil",
						"employer": "Conteq",
						"type": "Intranet Implementation",
						"title": "Intranet Implementation",
						"roles": [
							"Analyst",
							"Project Manager",
							"Developer",
							"Administrator"
						],
						"technologies": [
							"SharePoint 2013",
							"SharePoint"
						],
						"featured": "false"
					},
					{
						"title": "Intranet Boxed Solution Development",
						"client": "Conteq",
						"ending": "2013-11-23",
						"beginning": "2013-06-18",
						"clientLogo": "conteqlogo.png",
						"clientIndustry": "Energy",
						"employer": "Conteq",
						"type": "Custom Development",
						"roles": [
							"Analyst",
							"Developer",
							"Administrator"
						],
						"technologies": [
							"SharePoint 2013",
							"SharePoint"
						]
					},
					{
						"beginning": "2013-07-01",
						"ending": "2013-09-31",
						"client": "585",
						"clientLogo": "585logo.png",
						"clientIndustry": "Jewelry",
						"employer": "Conteq",
						"type": "Custom development",
						"title": "Freelance Job Administration",
						"roles": [
							"Analyst",
							"Developer",
							"Administrator",
							"Architect"
						],
						"technologies": [
							"SharePoint 2010",
							"SharePoint"
						],
						"featured": "false"
					},
					{
						"beginning": "2013-04-15",
						"ending": "2013-08-15",
						"client": "Agat",
						"clientLogo": "agatlogo.png",
						"clientIndustry": "Science and Research",
						"employer": "Conteq",
						"type": "DMS implementation",
						"title": "DMS Implementation",
						"roles": [
							"Developer",
							"Administrator"
						],
						"technologies": [
							"SharePoint 2010",
							"SharePoint"
						]
					},
					{
						"beginning": "2013-04-28",
						"ending": "2013-06-15",
						"client": "Itaka",
						"clientLogo": "itakalogo.png",
						"clientIndustry": "Real Estate",
						"employer": "Conteq",
						"type": "Portal implementation",
						"title": "Intranet Portal",
						"roles": [
							"Analyst",
							"Administrator"
						],
						"technologies": [
							"SharePoint 2010",
							"SharePoint"
						]
					},
					{
						"beginning": "2013-03-14",
						"ending": "2013-04-18",
						"client": "Kirovsky zavod",
						"clientLogo": "kzlogo.png",
						"clientIndustry": "Industrial Manufacturing",
						"employer": "Conteq",
						"type": "Portal branding",
						"title": "Intranet Portal Branding",
						"roles": [
							"Analyst",
							"Developer"
						],
						"technologies": [
							"SharePoint 2010",
							"SharePoint"
						]
					},
					{
						"beginning": "2012-12-12",
						"ending": "2013-02-15",
						"client": "Yves Rocher",
						"clientLogo": "yvesrocherlogo.png",
						"clientIndustry": "Cosmetic Industry",
						"employer": "Conteq",
						"type": "Portal implementation",
						"title": "Intranet and Partner Portal",
						"roles": [
							"Analyst",
							"Project Manager",
							"Administrator",
							"Architect"
						],
						"technologies": [
							"SharePoint 2010",
							"SharePoint"
						],
						"featured": "false"
					},
					{
						"title": "Intranet Portal Upgrade",
						"client": "SevZap NTC",
						"ending": "2013-06-15",
						"beginning": "2013-04-28",
						"clientLogo": "sevzapntclogo.png",
						"clientIndustry": "Energy",
						"employer": "Conteq",
						"type": "Upgrade",
						"roles": [
							"Analyst",
							"Developer",
							"Administrator"
						],
						"technologies": [
							"SharePoint 2007",
							"SharePoint 2010"
						]
					},
					{
						"title": "Intranet Portal Maintenance",
						"client": "Rosvodokanal",
						"ending": "2013-11-15",
						"beginning": "2012-02-12",
						"clientLogo": "rosvodokanallogo.png",
						"clientIndustry": "Water Supply",
						"employer": "Conteq",
						"type": "Portal maintenance",
						"roles": [
							"Developer",
							"Administrator"
						],
						"technologies": [
							"SharePoint 2010",
							"SharePoint"
						]
					},
					{
						"beginning": "2012-09-13",
						"ending": "2013-02-21",
						"client": "BaltTransService (Transneft)",
						"clientLogo": "transpetroleumlogo.jpg",
						"clientIndustry": "Oil and Gaz",
						"employer": "Conteq",
						"type": "Portal implementation",
						"title": "Intranet Portal",
						"roles": [
							"Developer"
						],
						"technologies": [
							"SharePoint 2010",
							"SharePoint"
						]
					},
					{
						"title": "Intranet Portal and Tasks",
						"client": "Bushe",
						"ending": "2013-04-18",
						"beginning": "2012-08-28",
						"clientLogo": "bushelogo.png",
						"clientIndustry": "Eating Places",
						"employer": "Conteq",
						"type": "Portal implementation",
						"roles": [
							"Analyst",
							"Project Manager",
							"Administrator",
							"Architect",
							"Developer"
						],
						"technologies": [
							"SharePoint 2010",
							"SharePoint"
						]
					},
					{
						"title": "Document Management System",
						"client": "Logistics of East European Gaz Pipeline",
						"ending": "2012-07-25",
						"beginning": "2012-05-29",
						"clientLogo": "lseglogo.png",
						"clientIndustry": "Engineering",
						"employer": "Kentor",
						"type": "Document management system implementation",
						"roles": [
							"Developer",
							"Administrator"
						],
						"technologies": [
							"SharePoint 2010",
							"SharePoint"
						],
						"featured": "false"
					},
					{
						"title": "Intranet and Public Internet Site https://сацминэнерго.рф",
						"client": "Minenergo",
						"ending": "2012-07-12",
						"beginning": "2011-09-07",
						"clientLogo": "energyminlogo.png",
						"clientIndustry": "Public Services",
						"employer": "Conteq",
						"type": "Portal implementation",
						"roles": [
							"Analyst",
							"Administrator",
							"Architect",
							"Developer"
						],
						"technologies": [
							"SharePoint 2010",
							"SharePoint"
						]
					},
					{
						"title": "Look and Feel Requirements",
						"client": "Pulkovo",
						"ending": "2012-07-05",
						"beginning": "2012-03-22",
						"clientLogo": "pulkovologo.png",
						"employer": "Conteq",
						"roles": [
							"Project Manager",
							"Developer"
						],
						"technologies": [
							"SharePoint 2010",
							"SharePoint"
						],
						"featured": "false"
					},
					{
						"title": "Document Management System Implementation",
						"client": "Krylov State Research Center",
						"ending": "2012-06-08",
						"beginning": "2011-06-21",
						"clientLogo": "russialogo.png",
						"employer": "Conteq",
						"roles": [
							"Administrator",
							"Developer"
						],
						"technologies": [
							"SharePoint 2010",
							"SharePoint"
						],
						"featured": "false"
					},
					{
						"title": "Intranet Portal",
						"client": "Lenstroytrest",
						"ending": "2013-02-06",
						"beginning": "2012-11-28",
						"clientLogo": "lstlogo.png",
						"clientIndustry": "Construction",
						"employer": "Conteq",
						"type": "Portal implementation",
						"roles": [
							"Developer",
							"Architect",
							"Administrator"
						],
						"technologies": [
							"SharePoint 2010",
							"SharePoint"
						]
					},
					{
						"title": "Look and Feel Development",
						"client": "Tehnopark",
						"ending": "2012-01-26",
						"beginning": "2011-11-02",
						"clientLogo": "technoparklogo.png",
						"employer": "Conteq",
						"roles": [
							"Project Manager",
							"Developer"
						],
						"technologies": [
							"SharePoint 2010",
							"SharePoint"
						],
						"featured": "false"
					},
					{
						"title": "http://www.nso.ru Public Web Site",
						"client": "Novosibirsk Region Government",
						"ending": "2011-12-27",
						"beginning": "2011-10-11",
						"clientLogo": "novosibarealogo.png",
						"employer": "TechnofIT",
						"roles": [
							"Developer"
						],
						"technologies": [
							"SharePoint 2010",
							"SharePoint"
						],
						"featured": "false"
					},
					{
						"title": "Look and Feel Development",
						"client": "Bank SPB",
						"ending": "2011-10-14",
						"beginning": "2011-08-01",
						"clientLogo": "bankspblogo.png",
						"employer": "Conteq",
						"roles": [
							"Developer"
						],
						"technologies": [
							"SharePoint 2010",
							"SharePoint"
						],
						"featured": "false"
					},
					{
						"title": "Demo Environment Development",
						"client": "Conteq",
						"ending": "2011-02-05",
						"beginning": "2010-11-19",
						"clientLogo": "conteqlogo.png",
						"employer": "Conteq",
						"roles": [
							"Developer",
							"Architect",
							"Administrator"
						],
						"technologies": [
							"SharePoint 2010",
							"SharePoint"
						],
						"featured": "false"
					},
					{
						"title": "Intranet Implementation",
						"client": "TOMS group",
						"ending": "2011-08-25",
						"beginning": "2010-12-14",
						"clientLogo": "tomslogo.png",
						"employer": "Conteq",
						"roles": [
							"Developer",
							"Architect",
							"Administrator"
						],
						"technologies": [
							"SharePoint 2010",
							"SharePoint"
						],
						"featured": "false"
					},
					{
						"title": "Document Archive Implementation",
						"client": "Intary",
						"ending": "2011-05-06",
						"beginning": "2011-04-15",
						"clientLogo": "intarilogo.png",
						"employer": "Conteq",
						"roles": [
							"Developer",
							"Architect",
							"Administrator"
						],
						"technologies": [
							"SharePoint 2010",
							"SharePoint",
							"RBS"
						],
						"featured": "false"
					},
					{
						"title": "Employees Schedules Requirements",
						"client": "Cardif Russia",
						"ending": "2011-04-22",
						"beginning": "2011-02-16",
						"clientLogo": "cardiflogo.png",
						"employer": "Conteq",
						"roles": [
							"Analyst",
							"Architect",
							"Administrator"
						],
						"technologies": [
							"SharePoint 2010",
							"SharePoint"
						],
						"featured": "false"
					},
					{
						"title": "Look and Feel Development",
						"client": "Nienshanc",
						"ending": "2011-03-31",
						"beginning": "2011-03-09",
						"clientLogo": "nienshanclogo.png",
						"employer": "Conteq",
						"roles": [
							"Developer"
						],
						"technologies": [
							"SharePoint 2010",
							"SharePoint"
						],
						"featured": "false"
					},
					{
						"title": "EPM Migration",
						"client": "Gazprom Neft",
						"ending": "2010-12-02",
						"beginning": "2011-02-03",
						"clientLogo": "gplogo.png",
						"employer": "Conteq",
						"roles": [
							"Developer",
							"Administrator"
						],
						"technologies": [
							"SharePoint 2010",
							"SharePoint"
						],
						"featured": "false"
					},
					{
						"title": "Intranet Implementation",
						"client": "RAO ESV",
						"ending": "2010-11-26",
						"beginning": "2010-10-26",
						"clientLogo": "raoesvlogo.png",
						"employer": "Conteq",
						"roles": [
							"Developer",
							"Administrator"
						],
						"technologies": [
							"SharePoint 2010",
							"SharePoint"
						],
						"featured": "false"
					},
					{
						"title": "Intranet Implementation",
						"client": "Academpark",
						"ending": "2010-10-08",
						"beginning": "2010-05-31",
						"clientLogo": "academparklogo.png",
						"employer": "TechnofIT",
						"roles": [
							"Developer",
							"Administrator"
						],
						"technologies": [
							"SharePoint 2010",
							"SharePoint"
						],
						"featured": "false"
					},
					{
						"title": "Consolidating Collaboration Platform",
						"client": "MTS",
						"ending": "2010-10-23",
						"beginning": "2010-07-21",
						"clientLogo": "mtslogo.png",
						"employer": "Utilex IT 2000",
						"roles": [
							"Developer",
							"Administrator"
						],
						"technologies": [
							"SharePoint 2010",
							"SharePoint"
						],
						"featured": "false"
					},
					{
						"title": "Business Improvement Management",
						"client": "Utilex IT 2000",
						"ending": "2010-10-12",
						"beginning": "2009-10-01",
						"clientLogo": "utilexlogo.png",
						"employer": "Utilex IT 2000",
						"roles": [
							"Developer",
							"Administrator"
						],
						"technologies": [
							"SharePoint 2010",
							"SharePoint"
						],
						"featured": "false"
					},
					{
						"title": "Hiring Process Management Automation",
						"client": "Megafon",
						"ending": "2009-09-18",
						"beginning": "2008-10-14",
						"clientLogo": "megafonlogo.png",
						"employer": "Utilex IT 2000",
						"roles": [
							"Architect",
							"Administrator"
						],
						"technologies": [
							"SharePoint 2007",
							"SharePoint"
						],
						"featured": "false"
					},
					{
						"title": "Developing Energy Budgeting System",
						"client": "Alrosa",
						"ending": "2008-11-26",
						"beginning": "2007-06-01",
						"clientLogo": "alrosalogo.png",
						"employer": "Utilex IT 2000",
						"roles": [
							"Architect",
							"Developer",
							"Administrator"
						],
						"technologies": [
							"SharePoint 2007",
							"InfoPath",
							"SharePoint"
						],
						"featured": "true"
					},
					{
						"title": "EPM Deployment",
						"client": "Rusal",
						"ending": "2008-01-14",
						"beginning": "2007-12-16",
						"clientLogo": "rusallogo.png",
						"clientIndustry": "Media",
						"employer": "Maxsoft",
						"type": "EPM implementation",
						"roles": [
							"Developer",
							"Administrator"
						],
						"technologies": [
							"Project",
							"SharePoint"
						],
						"featured": "false"
					},
					{
						"title": "http://www.admkrsk.ru Public Web Site",
						"client": "Krasnoyarsk Government",
						"ending": "2007-02-02",
						"beginning": "2006-06-30",
						"clientLogo": "krskgovlogo.png",
						"clientIndustry": "Media",
						"employer": "Maxsoft",
						"type": "Intranet implementation",
						"roles": [
							"Developer",
							"Administrator"
						],
						"technologies": [
							"SharePoint Services 2.0",
							"SharePoint"
						],
						"featured": "false"
					},
					{
						"title": "Collaboration Portal Implementation",
						"client": "TV7 Krasnoyarsk",
						"ending": "2006-03-06",
						"beginning": "2005-11-30",
						"clientLogo": "tv7logo.png",
						"clientIndustry": "Media",
						"employer": "Maxsoft",
						"type": "Intranet implementation",
						"roles": [
							"Developer",
							"Administrator"
						],
						"technologies": [
							"SharePoint Services 2.0",
							"SharePoint"
						],
						"featured": "true"
					},
					{
						"title": "Intranet Portal Implementation",
						"client": "Maxsoft",
						"ending": "2006-02-19",
						"beginning": "2005-07-06",
						"clientLogo": "maxsoftlogo.png",
						"clientIndustry": "IT",
						"employer": "Maxsoft",
						"type": "Intranet implementation",
						"roles": [
							"Developer",
							"Administrator"
						],
						"technologies": [
							"SharePoint Services 2.0",
							"SharePoint"
						],
						"featured": "false"
					}
				]
			}
		},
		{
			"id": "contact",
			"title": "Contact",
			"anouncement": "I look forward to hearing from you",
			"icon": "Mail",
			"moodPhoto": "handshake",
			"text": "Currently I live and work in Stockholm, Sweden. However, I'm open for challenges from all over the world, so feel free to get in touch with me.",
			"contactLines": [
				{
					"class": "phone",
					"icon": "Phone",
					"number": "+46 708 966 119"
				},
				{
					"class": "linkedin",
					"url": "https://www.linkedin.com/in/sapozhkov"
				},
				{
					"class": "email",
					"icon": "Mail",
					"address": "alexander@sapozhkov.net"
				},
				{
					"class": "skype",
					"icon": "SkypeLogo",
					"profilename": "asapozhkov"
				}
			]
		}
	]
};


//////////////////
// WEBPACK FOOTER
// ./src/pagedata.json
// module id = 212
// module chunks = 0